<template>
  <section class="section about-sec">
    <div class="container">
      <div class="row align-items-center">
        <!-- صورة -->
        <div class="col-lg-6" data-aos="fade-down">
          <div class="about-img">
            <div class="about-exp">
              <span>+12 سنة من الخبرة</span>
            </div>
            <div class="abt-img">
              <img src="@/assets/img/about-us.png" class="img-fluid" alt="من نحن" />
            </div>
          </div>
        </div>

        <!-- محتوى -->
        <div class="col-lg-6" data-aos="fade-down">
          <div class="about-content">
            <h6>عن شركتنا</h6>
            <h2
              style="
                background: linear-gradient(45deg, #28a745, #20c997);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              "
            >
              أفضل الحلول لتأجير السيارات
            </h2>
            <p>
              نحن شركة متخصصة في تأجير السيارات، نوفر لعملائنا تجربة مميزة تجمع بين الراحة،
              الأمان، والأسعار التنافسية. هدفنا أن نجعل رحلتك أكثر سهولة ومتعة مع أسطول سيارات
              متنوع يلبي جميع احتياجاتك.
            </p>
            <p>
              سواء كنت تبحث عن سيارة اقتصادية للتنقل اليومي، أو سيارة فاخرة لمناسبة خاصة، أو
              سيارة دفع رباعي للرحلات الطويلة، فنحن هنا لنمنحك أفضل الخيارات بخدمة عالية
              الجودة وفريق دعم متواجد لخدمتك دائمًا.
            </p>
            <div class="row">
              <div class="col-md-6">
                <ul>
                  <li>أسطول متنوع من أحدث السيارات</li>
                  <li>خدمة عملاء متوفرة 24/7</li>
                </ul>
              </div>
              <div class="col-md-6">
                <ul>
                  <li>أسعار تنافسية وخطط مرنة</li>
                  <li>إجراءات حجز سريعة وسهلة</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- /محتوى -->
      </div>
    </div>
  </section>
</template>
